import * as React from 'react';

function SvgIconMediaMute(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M14.472 22.053l7.288 5.467a1.061 1.061 0 001.117.101c.362-.181.59-.55.59-.955V13.058l-8.995 8.995zM5.333 21.333h5.334l12.8-12.8v-3.2a1.068 1.068 0 00-1.707-.853l-8.249 6.187H5.333c-.59 0-1.066.476-1.066 1.066v8.534c0 .59.476 1.066 1.066 1.066z"
        fill="currentColor"
      />
      <path
        d="M4.267 28.8a1.065 1.065 0 01-.754-1.82L26.979 3.512a1.065 1.065 0 111.508 1.508L5.021 28.487a1.064 1.064 0 01-.754.313z"
        fill="currentColor"
      />
    </svg>
  );
}

export const IconMediaMute = React.memo(SvgIconMediaMute);
